import { Route, Routes } from 'react-router-dom';

import PopupsFormV2 from './Form/PopupsFormV2';
import PopupsTable from './PopupsTable';

import '../../views/view.scss';

const PopupsView = () => {
  return (
    <Routes>
      <Route path="/" element={<PopupsTable />} />
      <Route path="/form" element={<PopupsFormV2 />} />
      <Route path="/form/:popupId" element={<PopupsFormV2 edit={true} />} />
      <Route
        path="/dup/:popupId"
        element={<PopupsFormV2 edit={false} dup={true} />}
      />
    </Routes>
  );
};

export default PopupsView;
